import * as React from 'react';
import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { createContext as createTop3ReviewsContext } from '@cian/top3-reviews-widget';
import * as ReactDOM from 'react-dom';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';
import { TReduxStore } from '../../../shared/types/redux';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();
  const { store } = dependencies;

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  const reviewsServerUrl = config.get<string>('reviews.serverUrl');

  const top3ReviewsContext = createTop3ReviewsContext(
    {
      httpClient: httpApi,
      apiBaseUrl: reviewsServerUrl as string,
    },
    store.getState().reviews || undefined,
  );

  ReactDOM.hydrate(
    <Application
      config={config}
      logger={logger}
      httpApi={httpApi}
      reduxStore={store}
      customContext={customContext}
      top3ReviewsContext={top3ReviewsContext}
    />,
    rootElement,
  );
}
